import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4TheftCoverageArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'Does HO-4 Cover Theft? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', 'Learn when HO-4 renters insurance covers theft, including common limits, exclusions, and claim tips.');
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/does-ho4-cover-theft"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>Does HO-4 cover theft (including outside the apartment)?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>In many cases yes, but policy limits, exclusions, and documentation matter.</p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4"><div className="card-body">
            <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
            <p>HO-4 policies commonly cover theft of personal belongings, including some losses away from home, subject to terms and limits in your policy.</p>
            <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>What to check in your policy</h3>
            <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>Personal property limit.</li>
              <li style={{ marginBottom: '0.5rem' }}>Deductible amount.</li>
              <li style={{ marginBottom: '0.5rem' }}>Sub-limits for high-value items.</li>
              <li>Required documentation for claims.</li>
            </ul>
            <p style={{ marginTop: '1rem', marginBottom: 0 }}>
              If you are just getting started, read <Link to="/knowledge-base/what-is-ho4-renters-insurance" style={articleLinkStyle}>what HO-4 covers</Link> and <Link to="/knowledge-base/how-to-get-ho4-renters-insurance" style={articleLinkStyle}>how to get HO-4</Link>.
            </p>
          </div></article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>Get coverage options with limits that fit your belongings.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Need help understanding theft limits?</h3>
              <p style={{ marginBottom: '1rem' }}>An agent can explain sub-limits and endorsement options for valuables.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4TheftCoverageArticlePage;

